export const SURGE_RECOMMENDATION = 10; // Percent
export const SURGE_RECOMMENDATION_PERCENTAGE = SURGE_RECOMMENDATION / 100;
